
import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ImagePreviewProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({
  isOpen,
  onClose,
  imageUrl,
}) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4 backdrop-blur-md animate-fade-in"
      onClick={onClose}
    >
      <div 
        className="max-w-6xl w-full max-h-[95vh] bg-background/10 backdrop-blur-sm rounded-2xl shadow-2xl overflow-hidden relative animate-scale-in border border-white/10"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="absolute top-4 right-4 z-10">
          <Button
            variant="secondary"
            size="icon"
            className="h-10 w-10 rounded-full bg-black/50 text-white hover:bg-black/70 border border-white/20 backdrop-blur-sm transition-all duration-200"
            onClick={onClose}
          >
            <X className="h-5 w-5" />
          </Button>
        </div>
        
        <div className="flex items-center justify-center p-8 h-full min-h-[50vh]">
          <img
            src={imageUrl}
            alt="Preview"
            className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl"
          />
        </div>
      </div>
    </div>
  );
};
